var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "business-profile-container" }, [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "loading-overlay" },
          [
            _c("a-spin", {
              attrs: {
                size: "large",
                tip: _vm.$t("whatsapp_business_api.loadingProfile"),
              },
            }),
          ],
          1
        )
      : _c("div", { staticClass: "business-profile-content" }, [
          _c("div", { staticClass: "profile-header-bar" }, [
            _c("div", { staticClass: "header-left" }, [
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  _vm._s(_vm.$t("whatsapp_business_api.businessProfileTitle"))
                ),
              ]),
              _vm._v(" "),
              _vm.profile.lastSyncedAt
                ? _c("span", { staticClass: "last-sync-time" }, [
                    _c("i", { staticClass: "fa fa-clock-o" }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("whatsapp_business_api.lastUpdate")) +
                        " " +
                        _vm._s(_vm.formatDate(_vm.profile.lastSyncedAt)) +
                        "\n                "
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "header-right" },
              [
                _c(
                  "a-button",
                  {
                    attrs: {
                      type: "primary",
                      loading: _vm.refreshing,
                      disabled: !_vm.canRefresh,
                      size: "large",
                    },
                    on: { click: _vm.refreshProfile },
                  },
                  [
                    _c("i", { staticClass: "fa fa-refresh" }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("whatsapp_business_api.updateFromMeta")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                !_vm.canRefresh
                  ? _c("div", { staticClass: "refresh-cooldown" }, [
                      _c("i", { staticClass: "fa fa-hourglass-half" }),
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t("whatsapp_business_api.waitSeconds", {
                              n: _vm.remainingTime,
                            })
                          ) +
                          "\n                "
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "waba-status-section" }, [
            _c("h3", { staticClass: "section-title" }, [
              _vm._v(_vm._s(_vm.$t("whatsapp_business_api.wabaInfoTitle"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "status-cards-primary" }, [
              _c("div", { staticClass: "status-card-large" }, [
                _c("div", { staticClass: "card-header" }, [
                  _c("i", { staticClass: "fa fa-phone" }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("whatsapp_business_api.phoneInfo"))),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("whatsapp_business_api.verifiedNameLabel")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "info-value verified" }, [
                      _vm._v(_vm._s(_vm.profile.wabaInfo.verifiedName)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("whatsapp_business_api.phoneNumberLabel"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "info-value" }, [
                      _vm._v(_vm._s(_vm.profile.wabaInfo.displayPhoneNumber)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("whatsapp_business_api.codeVerificationLabel")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "info-value",
                        class:
                          _vm.profile.wabaInfo.codeVerificationStatus ===
                          "VERIFIED"
                            ? "verified"
                            : "pending",
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.profile.wabaInfo.codeVerificationStatus
                            ) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "status-card-large" }, [
                _c("div", { staticClass: "card-header" }, [
                  _c("i", { staticClass: "fa fa-info-circle" }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("whatsapp_business_api.accountStatus"))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("whatsapp_business_api.accountStatus")) +
                          ": "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "info-value",
                        class:
                          "status-" +
                          _vm.profile.wabaInfo.accountStatus.toLowerCase(),
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.accountStatus[
                                _vm.profile.wabaInfo.accountStatus
                              ].text
                            ) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("whatsapp_business_api.phoneQuality")) +
                          ": "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "info-value",
                        class:
                          "quality-" +
                          _vm.profile.wabaInfo.phoneQuality.toLowerCase(),
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.phoneQuality[
                                _vm.profile.wabaInfo.phoneQuality
                              ].text
                            ) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("whatsapp_business_api.accountModeLabel"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "info-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.profile.wabaInfo.accountMode ||
                            _vm.$t("whatsapp_business_api.na")
                        )
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "status-card-large" }, [
                _c("div", { staticClass: "card-header" }, [
                  _c("i", { staticClass: "fa fa-cog" }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("whatsapp_business_api.platformSettings"))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("whatsapp_business_api.platformTypeLabel")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "info-value" }, [
                      _vm._v(_vm._s(_vm.profile.wabaInfo.platformType)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("whatsapp_business_api.throughputLevelLabel")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "info-value" }, [
                      _vm._v(_vm._s(_vm.profile.wabaInfo.throughputLevel)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-row" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("whatsapp_business_api.twoFaPinLabel"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "info-value",
                        class: _vm.profile.wabaInfo.isPinEnabled
                          ? "verified"
                          : "",
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.profile.wabaInfo.isPinEnabled
                                ? _vm.$t("whatsapp_business_api.enabled")
                                : _vm.$t("whatsapp_business_api.disabled")
                            ) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "status-cards-secondary" }, [
              _c(
                "div",
                {
                  staticClass: "status-mini-card",
                  class:
                    _vm.accountStatus[_vm.profile.wabaInfo.accountStatus].color,
                },
                [
                  _c("i", { staticClass: "fa fa-shield card-icon" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-content" }, [
                    _c("div", { staticClass: "card-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.accountStatus[_vm.profile.wabaInfo.accountStatus]
                            .text
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("whatsapp_business_api.accountStatus"))
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "status-mini-card",
                  class:
                    _vm.phoneQuality[_vm.profile.wabaInfo.phoneQuality].color,
                },
                [
                  _c("i", { staticClass: "fa fa-star card-icon" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-content" }, [
                    _c("div", { staticClass: "card-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.phoneQuality[_vm.profile.wabaInfo.phoneQuality]
                            .text
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("whatsapp_business_api.phoneQuality"))
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "status-mini-card success" }, [
                _c("i", { staticClass: "fa fa-paper-plane card-icon" }),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("div", { staticClass: "card-value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatMessagingLimit(
                          _vm.profile.wabaInfo.messagingLimit
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-label" }, [
                    _vm._v(_vm._s(_vm.$t("whatsapp_business_api.dailyLimit"))),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "status-mini-card",
                  class:
                    _vm.canSendMessage[_vm.profile.wabaInfo.canSendMessage]
                      .color,
                },
                [
                  _c("i", { staticClass: "fa fa-bolt card-icon" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-content" }, [
                    _c("div", { staticClass: "card-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.canSendMessage[
                            _vm.profile.wabaInfo.canSendMessage
                          ].text
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("whatsapp_business_api.messageSending"))
                      ),
                    ]),
                  ]),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "profile-info-section" }, [
            _c("h3", { staticClass: "section-title" }, [
              _vm._v(_vm._s(_vm.$t("whatsapp_business_api.businessInfoTitle"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "profile-grid" }, [
              _c("div", { staticClass: "profile-picture-card" }, [
                _c("div", { staticClass: "card-label" }, [
                  _vm._v(_vm._s(_vm.$t("whatsapp_business_api.profilePhoto"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-picture" }, [
                  _c("img", {
                    attrs: {
                      src:
                        _vm.profile.profilePictureUrl || "/default-avatar.png",
                      alt: "Profile",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "picture-upload-overlay" },
                    [
                      _c(
                        "a-upload",
                        {
                          attrs: {
                            beforeUpload: _vm.handleProfilePictureUpload,
                            showUploadList: false,
                            accept: "image/*",
                          },
                        },
                        [
                          _c(
                            "a-button",
                            { attrs: { type: "primary", size: "small" } },
                            [
                              _c("i", { staticClass: "fa fa-camera" }),
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.$t("whatsapp_business_api.change")
                                  ) +
                                  "\n                                "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-picture-note" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("whatsapp_business_api.profilePhotoNote")) +
                      "\n                    "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-field full-width" },
                [
                  _c("label", { staticClass: "field-label" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("whatsapp_business_api.aboutText")) +
                        " "
                    ),
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                  ]),
                  _vm._v(" "),
                  _c("a-textarea", {
                    attrs: {
                      "auto-size": { minRows: 3, maxRows: 5 },
                      placeholder: _vm.$t(
                        "whatsapp_business_api.aboutPlaceholder"
                      ),
                      maxLength: 139,
                      showCount: "",
                    },
                    model: {
                      value: _vm.profile.about,
                      callback: function ($$v) {
                        _vm.$set(_vm.profile, "about", $$v)
                      },
                      expression: "profile.about",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-hint" }, [
                    _vm._v(_vm._s(_vm.$t("whatsapp_business_api.aboutHint"))),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-field full-width" },
                [
                  _c("label", { staticClass: "field-label" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("whatsapp_business_api.businessDescriptionLabel")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c("a-textarea", {
                    attrs: {
                      "auto-size": { minRows: 4, maxRows: 6 },
                      placeholder: _vm.$t(
                        "whatsapp_business_api.businessDescriptionPlaceholder"
                      ),
                      maxLength: 512,
                      showCount: "",
                    },
                    model: {
                      value: _vm.profile.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.profile, "description", $$v)
                      },
                      expression: "profile.description",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-hint" }, [
                    _vm._v(
                      _vm._s(_vm.$t("whatsapp_business_api.descriptionHint"))
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c("label", { staticClass: "field-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("whatsapp_business_api.contactEmail"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-input",
                    {
                      attrs: {
                        placeholder: _vm.$t(
                          "whatsapp_business_api.emailPlaceholder"
                        ),
                        type: "email",
                      },
                      model: {
                        value: _vm.profile.email,
                        callback: function ($$v) {
                          _vm.$set(_vm.profile, "email", $$v)
                        },
                        expression: "profile.email",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-envelope",
                        attrs: { slot: "prefix" },
                        slot: "prefix",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c("label", { staticClass: "field-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("whatsapp_business_api.businessAddress"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-input",
                    {
                      attrs: {
                        placeholder: _vm.$t(
                          "whatsapp_business_api.addressPlaceholder"
                        ),
                      },
                      model: {
                        value: _vm.profile.address,
                        callback: function ($$v) {
                          _vm.$set(_vm.profile, "address", $$v)
                        },
                        expression: "profile.address",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-map-marker",
                        attrs: { slot: "prefix" },
                        slot: "prefix",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c("label", { staticClass: "field-label" }, [
                    _vm._v(_vm._s(_vm.$t("whatsapp_business_api.website1"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-input",
                    {
                      attrs: {
                        placeholder: _vm.$t(
                          "whatsapp_business_api.website1Placeholder"
                        ),
                      },
                      on: { change: _vm.updateWebsites },
                      model: {
                        value: _vm.websiteInputs.website1,
                        callback: function ($$v) {
                          _vm.$set(_vm.websiteInputs, "website1", $$v)
                        },
                        expression: "websiteInputs.website1",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-globe",
                        attrs: { slot: "prefix" },
                        slot: "prefix",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c("label", { staticClass: "field-label" }, [
                    _vm._v(_vm._s(_vm.$t("whatsapp_business_api.website2"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-input",
                    {
                      attrs: {
                        placeholder: _vm.$t(
                          "whatsapp_business_api.website2Placeholder"
                        ),
                      },
                      on: { change: _vm.updateWebsites },
                      model: {
                        value: _vm.websiteInputs.website2,
                        callback: function ($$v) {
                          _vm.$set(_vm.websiteInputs, "website2", $$v)
                        },
                        expression: "websiteInputs.website2",
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-globe",
                        attrs: { slot: "prefix" },
                        slot: "prefix",
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-field full-width" },
                [
                  _c("label", { staticClass: "field-label" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t("whatsapp_business_api.businessCategory")
                        ) +
                        " "
                    ),
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-select",
                    {
                      attrs: {
                        size: "large",
                        placeholder: _vm.$t(
                          "whatsapp_business_api.selectBusinessCategory"
                        ),
                      },
                      model: {
                        value: _vm.profile.vertical,
                        callback: function ($$v) {
                          _vm.$set(_vm.profile, "vertical", $$v)
                        },
                        expression: "profile.vertical",
                      },
                    },
                    _vm._l(_vm.verticals, function (vertical) {
                      return _c(
                        "a-select-option",
                        {
                          key: vertical.value,
                          attrs: { value: vertical.value },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(vertical.label) +
                              "\n                        "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "field-hint" }, [
                    _vm._v(
                      _vm._s(_vm.$t("whatsapp_business_api.categoryHint"))
                    ),
                  ]),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.hasChanges
            ? _c(
                "div",
                { staticClass: "action-bar" },
                [
                  _c(
                    "a-button",
                    { attrs: { size: "large" }, on: { click: _vm.resetForm } },
                    [
                      _c("i", { staticClass: "fa fa-undo" }),
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t("whatsapp_business_api.revertChanges")
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "large",
                        loading: _vm.isSaving,
                      },
                      on: { click: _vm.saveProfile },
                    },
                    [
                      _c("i", { staticClass: "fa fa-save" }),
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("whatsapp_business_api.updateButton")) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }